import { RestreamDestinationsProps } from "./RestreamDestinationsTypes";
import { translate } from "@kaltura/mediaspace-shared-utils";
import RestreamDestinations from "./RestreamDestinations";
import { StyledFormLabel } from "@kaltura/mediaspace-shared-ui";

/**
 * Restream destinations tab section for the DS edit entry page.
 */
export const RestreamDestinationsTabSection = (props: RestreamDestinationsProps) => {
    return (
        <div>
            <StyledFormLabel
                text={translate("Restream destinations")}
                additionalInfo={translate(
                    "Use restream to concurrently broadcast the event with additional streaming services such as social media."
                )}
                fontWeightBold={true}
            />

            <RestreamDestinations {...props} />
        </div>
    );
};
